.root {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
  margin-top: 1.5rem;
  min-width: 0;
}

.label {
  font-size: 0.875rem;
  font-weight: 500;
}

.prompt {
  max-width: 100%;
  height: auto;
  padding: 0.75rem 1rem;
  text-align: start;
  white-space: normal;
  font-size: 0.8125rem;
  line-height: 1.5;

  span { min-width: 0; overflow-wrap: anywhere; }
  svg { flex-shrink: 0; }
}
